import { useState } from 'react';

import { faFolder, faSave, faTimes } from '@fortawesome/pro-light-svg-icons';
import { useDispatch, useSelector } from 'hooks';
import { deletePlanGroup, savePlanGroup } from 'redux/actionCreators';

import { PlanGroup } from 'components/types';

import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';

import { FontAwesomeSvgIcon } from 'components/shared';

export type PlanGroupType = Omit<PlanGroup, 'uniqId' | 'id'> & {
  isNew?: boolean;
  id: string | number;
};

type Props = {
  planGroup: PlanGroupType;
} & (
  | {
      isSelected: true;
    }
  | {
      isSelected: false;
      onSelected: (planGroup: PlanGroupType) => void;
    }
);

export default function PlanGroupComponent(props: Props) {
  const { planGroup, isSelected } = props;
  const dispatch = useDispatch();
  const planGroups = useSelector((state) => state.planGroups);
  const { name, id, isNew } = planGroup;
  const [newName, setNewName] = useState<string>(name);
  const [isInvalidName, setIsInvalidName] = useState<boolean>(false);

  const onNameChanged = (e) => {
    const { value } = e.target;
    const plangGroups = planGroups.filter(({ id }) => id !== planGroup.id);
    setIsInvalidName(plangGroups.some(({ name }) => name === value));
    setNewName(e.target.value);
  };

  return (
    <div className="d-flex item">
      {isSelected === true ? (
        <>
          <ListItem dense selected>
            <FontAwesomeSvgIcon icon={faFolder} className="has-icon" />
            <TextField
              defaultValue={planGroup.name}
              error={isInvalidName}
              onChange={onNameChanged}
            />
          </ListItem>
          <IconButton
            color="primary"
            disabled={
              isInvalidName ||
              (planGroup.name === newName && !isNew) ||
              !newName
            }
            onClick={() => {
              dispatch(
                savePlanGroup({
                  isNew,
                  id,
                  name: newName || planGroup.name,
                  costCenters: planGroup.costCenters.slice()
                })
              );
            }}
          >
            <FontAwesomeSvgIcon icon={faSave} />
          </IconButton>
        </>
      ) : (
        <>
          <ListItem dense button onClick={() => props.onSelected(planGroup)}>
            <FontAwesomeSvgIcon icon={faFolder} className="has-icon" />
            <ListItemText primary={planGroup.name} />
          </ListItem>
          <IconButton
            color="primary"
            onClick={() => {
              dispatch(deletePlanGroup(id));
            }}
          >
            <FontAwesomeSvgIcon icon={faTimes} />
          </IconButton>
        </>
      )}
    </div>
  );
}
